import { inject } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';
import { CanActivateFn, Router } from '@angular/router';
import { from, map, of, switchMap, take } from 'rxjs';

/**
 * Protects application routes while allowing accounts created before email
 * verification enforcement to continue using the application.
 */
export const AuthGuard: CanActivateFn = () => {
  const auth = inject(Auth);
  const firestore = inject(Firestore);
  const router = inject(Router);

  return authState(auth).pipe(
    take(1),
    switchMap(user => {
      if (!user) {
        return of(router.parseUrl('/login'));
      }
      if (user.emailVerified) {
        return of(true);
      }

      // Existing accounts predate verification enforcement and remain usable.
      // New password users are not provisioned until verification succeeds.
      return from(getDoc(doc(firestore, `users/${user.uid}`))).pipe(
        map(snapshot => snapshot.exists() ? true : router.parseUrl('/verify-email'))
      );
    })
  );
};
